import { cloneDeep } from 'lodash';

import type { Pagination } from '../../../models';
import { Permissions } from '../../../models/Permissions';
import type { SortSettings } from '../../../models/SortSettings';
import { AssetForm } from '../../forms';
import { EditMultipleForm } from './EditMultipleForm';
import { SearchForm } from './SearchForm';

export const initialPagination = {
  sortBy: 'publicationDate',
  descending: true,
  rowsPerPage: 100,
  page: 1,
  totalItems: 0,
  pages: 1,
};

// note that because of the way vue js works we have to give the attributes values right off the bat, otherwise they won't be watched by vue js correctly...ideally
//   we wouldn't repeat the same settings in reset() below here, but no other values make sense, so just go ahead and repeat them (safer as well)...
export class AssetsListingState {
  permissions: Permissions = new Permissions([]);
  assetDisplayNameEnabled: boolean = false;

  isSidebarShowing: boolean = false;
  searchForm: SearchForm = new SearchForm();

  assetForm: AssetForm = new AssetForm();

  editMultipleForm: EditMultipleForm = EditMultipleForm.create([], { sortBy: 'publicationDate', descending: true }, '');

  lastSortSettings: SortSettings = { sortBy: initialPagination.sortBy, descending: initialPagination.descending };
  pagination: Pagination = cloneDeep(initialPagination);

  selectedItemIds: Array<string> = [];
  searchKeyword: string = '*';
  playListDuration: number = 0;

  legendConfigs = { nestedCollection: false, clipGroup: false, liveEvent: false };

  constructor() { }

  static create() {
    const obj = new AssetsListingState();
    obj.reset();
    return obj;
  }

  reset() {
    this.isSidebarShowing = false;
    this.searchForm = new SearchForm();

    // the need for schemas as part of its creation means i can't get this into a valid state right off the bat and i don't think
    //   i want to make this nullable...up to the rest of the code to manage it correctly...
    this.assetForm = new AssetForm();

    // initial values here don't really matter, but i need to specify something because i'd prefer to deal with editMultipleForm not including
    //   null in its type signature...
    this.editMultipleForm = EditMultipleForm.create([], { sortBy: 'publicationDate', descending: true }, '');

    this.lastSortSettings = { sortBy: initialPagination.sortBy, descending: initialPagination.descending };
    this.legendConfigs = { nestedCollection: false, clipGroup: false, liveEvent: false };
    (this.pagination = cloneDeep(initialPagination)), (this.selectedItemIds = []);
  }
}
